import { useLocation } from "wouter";
import { useState, useRef, useEffect, useContext } from "react";
import { SvgIconComponent } from "../../Atoms/Icons/SvgIconComponent";
import "./MenuVerticalItem.scss";
import MenuContext from "../../../context/MenuContext";

const INITIAL_COLOR_SVG = "#0466C8";
const COLOR_SVG_HOVER = "#151B26";

const MenuVerticalItem = ({ clickMenu, icon, title = "Default menu", setShowSubmenu, index, showSubmenu, href }) => {
  const [location, setLocation] = useLocation();
  const [hover, setHover] = useState(false);
  const menuItem = useRef();
  const isActive = location.includes(href.toLowerCase());
  const { setIsMenuOpen } = useContext(MenuContext)  

  const clickHandler = () => {
    setShowSubmenu(false);
    setIsMenuOpen(false) // MenuContext
    setLocation("/dashboard");
  };
  
  useEffect(() => {
    if (index === 0) {
      menuItem.current.addEventListener("click", clickHandler);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOver = (menuItem) => {
    setHover(true)
    Array.from(menuItem.current.parentNode.children).forEach((element) => {
      if(element !== menuItem.current) {
        element.classList.remove('activeHover')
      } else {
        menuItem.current.classList.add('activeHover')
      }  
    });
  }

  const handleLeave = () => {
    Array.from(menuItem.current.parentNode.children).forEach((element) => {
      element.classList.remove('activeHover')
    });
    setHover(false)
    // if(!isMenuOpen) { // isMenuOpen de MenuContext 
    //   Array.from(menuItem.current.parentNode.children).forEach((element) => {
    //     element.classList.remove('activeHover')
    //   });
    // }
  }

  return (
    <div onClick={() => clickMenu(index)} className={`menu-vertical__item s-cross-center s-main-center ${isActive ? "active": ""}`} onMouseEnter={() => handleOver(menuItem)} onMouseLeave={() => handleLeave(menuItem)} ref={menuItem} data-index={index}  >
      <SvgIconComponent 
        width='100%'
        height='1.3rem'
        fill={isActive || hover ? COLOR_SVG_HOVER : INITIAL_COLOR_SVG} 
        path_d={icon}  
      />
      <p className="menu-vertical__title mt-10 s-main-center">{title}</p>
    </div>
  );
};

export default MenuVerticalItem;
